import { getDeveloperApi } from '@squareup/dex-data-shared-developer-api';
import { TechRefStoreState } from '@squareup/dex-tech-shell';

import {
  selectGraphEntitiesInView,
  selectSpecVersionInView,
} from './selectors';

/**
 * Error selectors are needed as they compose the error hierarchy for consumers.
 * These should climb the data models to find the closes error.
 */

// Specs
const selectParsedGraphInfoError = (state: TechRefStoreState) => {
  // Version Slice
  const { error: versionError, versionInfo } = selectSpecVersionInView(state);

  if (versionError) {
    return versionError;
  }

  if (!versionInfo) {
    return undefined;
  }

  // Spec Slice
  const { error: specError } =
    getDeveloperApi().endpoints.getSpecification.select(versionInfo)(state);
  return specError;
};

// Graph entities in view
const selectGraphEntitiesInViewError = (state: TechRefStoreState) => {
  return selectGraphEntitiesInView(state).error;
};

const selectAnyGraphInViewError = (state: TechRefStoreState) => {
  return (
    selectParsedGraphInfoError(state) || selectGraphEntitiesInView(state).error
  );
};

export {
  selectParsedGraphInfoError,
  selectGraphEntitiesInViewError,
  selectAnyGraphInViewError,
};
